import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Paper, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const PageRemoved = () => (
  <Box
    sx={{
      height: '85vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
    }}
  >
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 500,
        textAlign: 'center',
        borderRadius: 3,
      }}
    >
      <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
      <WsTypography variant={WsTypoVariants.H2} color={WsTypoColors.ERROR} bold>
        404
      </WsTypography>
      <Box mt={1}>
        <WsTypography variant={WsTypoVariants.TITLE}>
          Resource&nbsp;&nbsp;Not&nbsp;&nbsp;Found
        </WsTypography>
      </Box>
      <Box mb={3}>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
          The page you’re looking for has been removed or is no longer available.
        </WsTypography>
      </Box>
      <Box mb={3}>
        <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
          If you believe this is a mistake, please contact your administrator.
        </WsTypography>
      </Box>
      <RouterLink to="/home" style={{ textDecoration: 'none' }}>
        <Button variant="contained" color="primary">
          Go to Homepage
        </Button>
      </RouterLink>
    </Paper>
  </Box>
);

export default PageRemoved;
